import { createReducer } from "@reduxjs/toolkit";
import {
  FIELD_NAMES_ERROR,
  FIELD_NAMES_LOADING,
  GET_FIELD_NAMES,
} from "../actions/types";

const initialState = {
  error: "",
  loading: false,
  data: [],
};

const fieldNamesReducer = createReducer(initialState, (builder) => {
  builder
    .addCase(FIELD_NAMES_LOADING, (state) => {
      state.loading = true;
    })
    .addCase(FIELD_NAMES_ERROR, (state, { payload }) => {
      state.error = payload;
      state.loading = false;
    })
    .addCase(GET_FIELD_NAMES, (state, { payload }) => {
      state.data = payload;
      state.loading = false;
    });
});

export default fieldNamesReducer;
